export default "__VITE_ASSET__CB1v2N_x__"